<template>
  <main class="container-fluid">
    <div class="d-flex justify-content-center align-items-center" style="height: 100vh">
      <div class="card" style="width: 18rem">
        <img src="/expired-account.jpg" class="card-img-top" alt="account expired" />
        <div class="card-body">
          <p class="card-text">
            Your account has expired. Please contact support for help reactivating.
          </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script lang="ts" setup>
import { useSchoolStore } from "@/stores/school";
import { watch } from "vue";
import { useRouter } from "vue-router";

const schoolStore = useSchoolStore();
const router = useRouter();
schoolStore.loadSchool();

watch(
  () => schoolStore.school,
  (newData) => {
    if (newData) {
      if (schoolStore.school?.expiration_date && !schoolStore.isExpired()){
        router.push({ name: "school-events" });
      }
    }
  },
  { immediate: true } // This ensures the watcher runs immediately with the initial value
);

</script>
